module.exports = __webpack_public_path__ + "static/media/ff_ldap.e96f786d.png";